import { Permission } from '@chiroup/core/types/AdminUserRole.type';
import { useMemo } from 'react';
import useAdminMe from './useAdminMe';

export type UseAdminPermissions = {
  isLoading: boolean;
  hasPermission: (p: Permission) => boolean;
  hasAll: (ps: Permission[]) => boolean;
  hasAny: (ps: Permission[]) => boolean;
};

export const useAdminPermissions = (): UseAdminPermissions => {
  const { data, isLoading } = useAdminMe();
  return useMemo(() => {
    const set = new Set(data?.permissions ?? []);
    return {
      isLoading,
      hasPermission: p => set.has(p),
      hasAll: ps => ps.every(p => set.has(p)),
      hasAny: ps => ps.some(p => set.has(p)),
    };
  }, [data, isLoading]);
};
